import KeyCloakService from '@/security/KeycloakService';
import { createRouter, createWebHistory } from 'vue-router'
import {useEntidadeStore} from "@/stores/entidade";

const router = createRouter({
  history: createWebHistory('sincfolha2024'),
  routes: [
    {
      path: "/",
      component: () => import("@/views/EntidadesPageView.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/home",
      component: ()=> import('@/views/HomeView.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },
    {
      path: "/remessas",
      component: ()=> import('@/views/RemessasView.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },
    {
      path: "/uploads",
      component: ()=> import('@/views/UploadView.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },
    {
      path: "/visualizacao",
      component: ()=> import('@/views/VisualizarEnvio.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },
    {
      path: "/erros",
      component: ()=> import('@/views/TrilhasView.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },
    {
      path: "/erros/visualizacao",
      component: ()=> import('@/views/LinhasByTrilhaView.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },

    {
      path: "/recibo",
      component: ()=> import('@/views/ReciboView.vue'),
      meta: {
        auth: true,
        layout: 'DashboardLayout',
      },
    },
    {
      path: "/consulta-recibo",
      component: ()=> import('@/views/ConsultaReciboView.vue'),
      meta: {
        auth: false,
      },
    },
    {
      path: "/consulta-relatorio",
      component: ()=> import('@/views/ConsultaRelatorioView.vue'),
      meta: {
        auth: false,
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue'),
      meta: {
        auth: false,
        layout: 'DashboardLayout',
      },
    },
    {
      path: '/api-maintenance',
      name: 'ApiMaintenance',
      component: () => import('../views/ApiMaintenanceView.vue'),
      meta: {
        auth: false,
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const path = window.location.origin + process.env.BASE_URL + to.path;
  if (to.meta.auth) {
    if (!KeyCloakService.isAuthenticated()) {
        KeyCloakService.CallLogin(path).then(() => {
            next();
        });
    } else if (!useEntidadeStore().entidadeSelecionada && to.path !== '/') {
      console.log('entidade não selecionada');
      router.push({ path: '/' });
    } next();
  } else next();
});

export default router
